import { Account, Team, Member } from "@zapier/client";

export function isAccount(item: Account | Member | Team): item is Account {
  return "planInfo" in item;
}

export function isMember(item: Account | Member | Team): item is Member {
  return "email" in item;
}

export function isTeam(item: Account | Member | Team): item is Team {
  return "memberCount" in item;
}
